import 'keen-slider/keen-slider.min.css';

import React from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../context/ProductBuilder/machine';
import { getStateKey } from '../../helpers/getStateKey';
import { getStates } from '../../helpers/getStates';
import { throwError } from '../../helpers/throwError';
import { Sections } from './Section/Sections';

// Check for production
const isProd = process.env.NODE_ENV === 'production';

const Wrapper = styled.div<{
  isProd: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  ${({ isProd }) => {
    if (isProd) {
      return 'height: inherit';
    }
  }};

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
  * {
    font-family: var(--bs-font);
  }

  @media (min-width: 1441px) {
    height: 100%;
  }
`;

const State = styled.span`
  display: inline-block;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: #222;
  color: white;
  padding: 0.5em 1em;
  z-index: 2;
  font-size: 12px;
`;

const ProductBuilder = () => {
  const [state] = useService(productBuilderMachine);
  const productTypes = Array.from(
    new Set(state.context.products.map(product => product.type)),
  );

  const states = getStates(state.context);
  const isReady = states.includes(getStateKey(state.value));

  if (states.length === 0) {
    const additionalMessage = `Product Builder failed to start. No customisation options found for the following product types: ${productTypes.join(
      ', ',
    )}`;
    throwError(state, additionalMessage);
  }
  return (
    <Wrapper isProd={isProd}>
      {!isReady && <p>Loading</p>}
      {!isProd && <State>{state.toStrings()}</State>}
      {isReady && <Sections />}
    </Wrapper>
  );
};

export default ProductBuilder;
